import { getInsurancesAutoComplete } from '@medifind/interface';
import { StoreFilterAutocomplete } from '@medifind/search-results';
import { clearDoctorInsuranceFilterOption, updateDoctorInsuranceFilterOption, useFilterContext } from '@medifind/zustand';
import FilterChips from '../FilterChips';

const StoreInsuranceFilter = ({ ...props }) => {
  const filters = useFilterContext();
  const { doctorInsurance } = filters.states;
  const doctorInsuranceValues = doctorInsurance.selected;

  const handleDoctorInsuranceAutoComplete = async (input) => {
    try {
      const { results } = await getInsurancesAutoComplete(input);
      const filtered = results.map((ins) => {
        return {
          display: ins.display,
          value: ins.value,
          isDisabled: Boolean(doctorInsuranceValues?.find((v) => v.value === ins.value)),
        };
      });

      return filtered;
    } catch (e) {
      return [
        {
          display: 'Type a few more characters',
          value: '',
        },
      ];
    }
  };

  return (
    <>
      <StoreFilterAutocomplete
        filter={doctorInsurance}
        label="Insurance"
        placeholder={doctorInsuranceValues?.length ? `${doctorInsuranceValues.length} Selected` : 'Any'}
        onSelect={(item) => updateDoctorInsuranceFilterOption([...(doctorInsuranceValues || []), item])}
        autocompleteFunction={handleDoctorInsuranceAutoComplete}
        prepopulateOnFocus
        clearInputAfterSelect
        fullWidth
        actLikeASelect
        showClearButton
        clearSelect={(...args) => clearDoctorInsuranceFilterOption(...args)}
        {...props}
      />
      <FilterChips values={doctorInsuranceValues} onChipUpdate={(arr) => updateDoctorInsuranceFilterOption(arr)} />
    </>
  );
};
export { StoreInsuranceFilter as default, StoreInsuranceFilter };
